// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import type { State } from "src/types";
import { setEmailData } from "src/actions/email";

import { HStack, Text, Input } from "@chakra-ui/react";
import * as styles from "./styles";

type Props = {
  value: string,
  setEmailData: Function,
};

function Subject({ value, setEmailData }: Props) {
  const handleChange = (e) => {
    setEmailData({
      prop: "subject",
      value: e.target.value,
    });
  };

  return (
    <HStack {...styles.formItemFrame}>
      <Text {...styles.formLabel}>{i18n.t(k.SUBJECT)}</Text>
      <Input value={value} onChange={handleChange} {...styles.subjectInput} />
    </HStack>
  );
}

const mapStateToProps = ({ app }: State) => ({
  value: app.email.data.subject,
});

const mapDispatchToProps = {
  setEmailData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Subject);
